import { render, staticRenderFns } from "./gaisuan-result.vue?vue&type=template&id=0a077820&scoped=true"
import script from "./gaisuan-result.vue?vue&type=script&lang=js"
export * from "./gaisuan-result.vue?vue&type=script&lang=js"
import style0 from "./gaisuan-result.vue?vue&type=style&index=0&id=0a077820&prod&lang=css"
import style1 from "./gaisuan-result.vue?vue&type=style&index=1&id=0a077820&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a077820",
  null
  
)

export default component.exports